import { useTranslation } from "react-i18next"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import React, { JSX } from "react"

// message from thread
const ConfirmDialog = ({title, info, open, handleClose, onOk }: {title: string, info:string|JSX.Element, open: boolean, handleClose: any, onOk?: any}) => {
  const { t } = useTranslation()

  return <Dialog onClick={(e) => {e.stopPropagation()}} open={open}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      {info}
    </DialogContent>
    <DialogActions style={{textAlign:'right'}}>
      <Button onClick={(e) => {e.stopPropagation(); handleClose()}}>{t('Cancel')}</Button>
      <Button variant='contained' onClick={(e) => {e.stopPropagation(); if (onOk) onOk(); handleClose() }}>{t('OK')}</Button>
    </DialogActions>
  </Dialog>

}

export default ConfirmDialog